<!--
  ~ Copyright (c) 2020. Jellybean B.V. Apeldoorn
  ~ Jellybean B.V. Apeldoorn heeft een licentie verleend aan
  ~ Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
  ~ onderdelen in projecten voor derden. U heeft géén toestemming
  ~ tot inzage of wijziging in de (bron)code van deze onderdelen.
  -->

<div class="modal-header">
  <h4 class="modal-titel">{{ titel }}</h4>
</div>
<div class="modal-body">
  <p [innerHTML]="vraag"></p>
</div>
@if (confirm) {
  <div class="modal-footer">
    <button (click)="sluit(true)"
            class="btn btn-success float-left">{{ linkertekst }}
    </button>
    <button (click)="sluit(false)" class="btn btn-secondary float-right">
      {{ rechtertekst }}
    </button>
  </div>
} @else {
  <div class="modal-footer center">
    <button (click)="sluit(true)"
            class="btn btn-success center">{{ linkertekst }}
    </button>
  </div>
}
